module.exports = __webpack_public_path__ + "assets/img/dragon-idle.61520114.png";